import classNames from 'classnames';
import React from 'react';

interface TextProps extends React.HTMLAttributes<HTMLElement> {
	as?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
}

const Text = ({
	as: Tag = 'span',
	className,
	children,
	...props
}: TextProps) => {
	const baseClassName = {
		span: 'text-base font-normal',
		p: 'text-base leading-relaxed',
		h1: 'text-4xl font-black',
		h2: 'text-3xl font-extrabold',
		h3: 'text-2xl font-bold',
		h4: 'text-xl font-bold',
		h5: 'text-lg font-semibold',
	}[Tag];

	return (
		<Tag className={classNames(baseClassName, className)} {...props}>
			{children}
		</Tag>
	);
};

export default Text;
